<template>
  <div class="sign">
    <div class="sign_head" ref="head">
      <img class="sign_icon" src="../../assets/images/sign/icon-back.png" alt="" @click="back">
      <div>
        <button type="button" @click="clear">清除</button>
        <button type="button" @click="save">确定</button>
      </div>
    </div>
    <div class="sign_body">
      <span class="text">请横向签名</span>
      <canvas ref="canvas"></canvas>
    </div>

  </div>
</template>
<script>
  import SignaturePad from 'signature_pad'
  import Toast from './toast.js'

  export default {
    name: 'Sign',
    data() {
      return {
        signaturePad: null,
        from: null,
        preSignImg: null,
        preSignImgData: null,
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.from = from.name
        if (vm.signaturePad) {
          vm.signaturePad.clear()
          if (!to.params.needClear && vm.preSignImgData) {
            vm.signaturePad.fromData([...vm.preSignImgData])
          } else {
            vm.preSignImg = null
            vm.preSignImgData = null
          }
        }
      })
    },
    // watch: {
    //   preSignImgData() {
    //     console.log('change')
    //   }
    // },
    mounted() {
      window.addEventListener("resize", () => {
        this.$refs.canvas.width = this.$refs.canvas.clientWidth
        this.$refs.canvas.height = this.$refs.canvas.clientHeight
        this.signaturePad = new SignaturePad(this.$refs.canvas, {minWidth: 2});
      });

      this.$refs.canvas.width = this.$refs.canvas.clientWidth
      this.$refs.canvas.height = this.$refs.canvas.clientHeight
      this.signaturePad = new SignaturePad(this.$refs.canvas, {minWidth: 2});
    },
    methods: {
      clear() {
        this.signaturePad.clear()
      },
      back() {
        this.$router.replace({
          name: this.from,
          params: {url: this.preSignImg}
        })
      },
      save() {
        if (this.signaturePad.isEmpty()) {
          Toast('请签名')
        } else {
          this.savePreData()
          this.$router.push({name: this.from, params: {url: this.signaturePad.toDataURL()}})
        }
      },
      savePreData() {
        this.preSignImg = this.signaturePad.toDataURL()
        this.preSignImgData = this.signaturePad.toData()
      }
    }
  }
</script>
<style scoped>
  .sign {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #f8f8f8;
  }

  .sign_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.5rem;
    height: 1rem;
    background: #ffffff;
    text-align: center;
    font-size: 0.4rem;
    border-bottom: .013rem solid #c7c7c7;
  }

  .sign_head button {
    width: 1.33rem;
    height: 0.60rem;
    margin-left: .3rem;
    border-radius: 0.33rem;
    font-size: .3rem;
    color: #ffffff;
    border: none;
    background: #0D80FE;
  }

  .sign_body {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .45rem;
    color: #666666;
  }

  .text {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, 50%);
    z-index: -1;
  }

  .sign_body canvas {
    flex: 1;
    height: 100%;
    background: rgba(199, 199, 199, 0);
    /*opacity: 0;*/
  }

  .sign_icon {
    width: .4rem;
    margin-top: -.05rem;
    margin-right: .13rem;
  }
</style>



// WEBPACK FOOTER //
// Sign.vue?da6c97f6